import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import { Typography, Card, Spin, Button, Form, Row, Col, Flex, Steps } from "antd";

//PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import styles from "../../../assets/styles/styles";
import DetailForm from "./components/casaForms/DetailForm";
import CurrencyForm from "./components/casaForms/CurrencyForm";
import TermsForm from "./components/casaForms/TermsForm";
import SettingsForm from "./components/casaForms/SettingsForm";
import ChargeForm from "./components/casaForms/ChargeForm";
import AccountingForm from "./components/casaForms/accountingForm/AccountingForm";
import Preview from "./components/casaForms/Preview";
import { labelConfig, staticConfig, apiConfig } from "../product.config";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const AddPRD0100 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { Text, Title } = Typography;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();

  const [isLoading, setIsLoading] = useState(false);
  const [current, setCurrent] = useState(0);

  // ENDPOINT DECLARED VARIABLES
  const [formData, setFormData] = useState({
    details: null,
    currency: null,
    terms: null,
    settings: null,
    charges: null,
    account: null,
  });

  // ACCOUNTING FORM REQUIRED VARIABLES
  const [isDormancyTrackingActive, setIsDormancyTrackingActive] = useState(false);
  const [accountingRuleCheck, setAccountingRuleCheck] = useState("1");
  const [showAdvancedAccounting, setShowAdvancedAccounting] = useState(false);
  const [configureFundTableSource, setConfigureFundTableSource] = useState([]);
  const [mapFeeTableSource, setMapFeeTableSource] = useState([]);
  const [mapPenaltyTableSource, setMapPenaltyTableSource] = useState([]);

  // CHARGES FORM REQURED VARIABLES
  const [chargeTableSource, setChargeTableSource] = useState([]);
  const [radioCheck, setRadioCheck] = useState(true);

  // ENDPOINT DECLARED VARIABLES
  const [fundsData, setFundsData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [interestCompoundingPeriodTypeOptions, setInterestCompoundingPeriodTypeOptions] = useState(
    []
  );
  const [interestPostingPeriodTypeOptions, setInterestPostingPeriodTypeOptions] = useState([]);
  const [interestCalculationTypeOptions, setInterestCalculationTypeOptions] = useState([]);
  const [interestCalculationDaysInYearTypeOptions, setInterestCalculationDaysInYearTypeOptions] =
    useState([]);
  const [lockinPeriodFrequencyTypeOptions, setLockinPeriodFrequencyTypeOptions] = useState([]);
  const [taxGroupOptions, setTaxGroupOptions] = useState([]);
  const [assetAccountOptions, setAssetAccountOptions] = useState([]);
  const [equityAccountOptions, setEquityAccountOptions] = useState([]);
  const [expenseAccountOptions, setExpenseAccountOptions] = useState([]);
  const [incomeAccountOptions, setIncomeAccountOptions] = useState([]);
  const [liabilityAccountOptions, setLiabilityAccountOptions] = useState([]);
  const [paymentTypeOptions, setPaymentTypeOptions] = useState([]);
  const [charges, setCharges] = useState([]);
  const [chargesOptions, setChargesOptions] = useState([]);
  const [penaltyOptions, setPenaltyOptions] = useState([]);

  const currency = formData?.currency?.currencyCode;
  const filteredAssetAccountOptions = assetAccountOptions.filter(
    (item) => item.currencyCode === currency
  );
  const filteredEquityAccountOptions = equityAccountOptions.filter(
    (item) => item.currencyCode === currency
  );
  const filteredExpenseAccountOptions = expenseAccountOptions.filter(
    (item) => item.currencyCode === currency
  );
  const filteredIncomeAccountOptions = incomeAccountOptions.filter(
    (item) => item.currencyCode === currency
  );
  const filteredLiabilityAccountOptions = liabilityAccountOptions.filter(
    (item) => item.currencyCode === currency
  );
  console.log(filteredAssetAccountOptions);
  console.log(currency, formData, "currency");

  // DECLARED VARIABLES FOR CHARRGES FORM
  const [chargeBasedOnCurrencyList, setChargeBasedOnCurrencyList] = useState([]);
  const [chargesValue, setChargesValue] = useState(null);

  // DECLARED VARIABLES FOR ACCOUNT FORM
  const [templateProdDetail, setTemplateProdDetail] = useState({});
  const [fundCount, setFundCount] = useState(1);
  const [feeCount, setFeeCount] = useState(0);
  const [penaltyCount, setPenaltyCount] = useState(0);

  useEffect(() => {
    getTemplate();
  }, []);

  const onChangeCurrency = (currencyParam) => {
    const chargeForTableData = chargesOptions.filter((item) => item.currencyCode === currencyParam);
    useForm.setFieldsValue({
      chargeId: "",
    });
    setChargeBasedOnCurrencyList([...chargeForTableData]);
    setFormData({ ...formData, account: null });
    useForm.setFieldsValue({
      savingsReferenceAccountId: null,
      overdraftPortfolioControlId: null,
      savingsControlAccountId: null,
      transfersInSuspenseAccountId: null,
      escheatLiabilityId: null,
      interestOnSavingsAccountId: null,
      writeOffAccountId: null,
      incomeFromFeeAccountId: null,
      incomeFromPenaltyAccountId: null,
      incomeFromInterestId: null,
    });
    setConfigureFundTableSource(null);
    setMapFeeTableSource(null);
  };

  const handleRadioCheck = (e) => {
    const { name, value, checked } = e.target;
    setAccountingRuleCheck(value);
    setRadioCheck(checked);
  };

  const onFinishDetailsForm = (values) => {
    setFormData({ ...formData, details: values });
    setCurrent(current + 1);
  };

  const onFinishCurrencyForm = (values) => {
    setFormData({ ...formData, currency: values });
    setCurrent(current + 1);
  };

  const onFinishTermsForm = (values) => {
    setFormData({ ...formData, terms: values });
    setCurrent(current + 1);
  };

  const onFinishSettingsForm = (values) => {
    setFormData({ ...formData, settings: values });
    setCurrent(current + 1);
  };

  const onFinishChargeForm = (values) => {
    let tempChargeArray = [];
    chargeTableSource.forEach((element, index) => {
      tempChargeArray.push({
        id: element.id,
      });
    });

    values.charges = tempChargeArray;

    delete values.chargeId;

    setFormData({
      ...formData,
      charges: values.charges,
    });
    setCurrent(current + 1);
  };

  const onFinishAccountForm = (values) => {
    let tempPaymentChannelToFundSourceMappingsArray = [];
    let tempFeeToIncomeAccountMappingsArray = [];
    let tempPenaltyToIncomeAccountMappingsArray = [];

    configureFundTableSource?.forEach((element, index) => {
      tempPaymentChannelToFundSourceMappingsArray.push({
        paymentTypeId: element.paymentTypeId,
        fundSourceAccountId: element.fundSourceAccountId,
      });
    });

    mapFeeTableSource?.forEach((element, index) => {
      tempFeeToIncomeAccountMappingsArray.push({
        chargeId: element.chargeId,
        incomeAccountId: element.incomeAccountId,
      });
    });

    mapPenaltyTableSource?.forEach((element, index) => {
      tempPenaltyToIncomeAccountMappingsArray.push({
        paymentTypeId: element.paymentTypeId,
        fundSourceAccountId: element.fundSourceAccountId,
      });
    });

    values.paymentChannelToFundSourceMappings = tempPaymentChannelToFundSourceMappingsArray;
    values.feeToIncomeAccountMappings = tempFeeToIncomeAccountMappingsArray;
    values.penaltyToIncomeAccountMappings = tempPenaltyToIncomeAccountMappingsArray;

    setFormData({
      ...formData,
      account: values,
      paymentChannelToFundSourceMappings: values.paymentChannelToFundSourceMappings,
      feeToIncomeAccountMappings: values.feeToIncomeAccountMappings,
      penaltyToIncomeAccountMappings: values.penaltyToIncomeAccountMappings,
    });
    setCurrent(current + 1);
  };

  console.log(formData, currencyData, templateProdDetail);
  const forms = [
    <DetailForm onFinish={onFinishDetailsForm} form={useForm} formData={formData.details} />,
    <CurrencyForm
      onFinish={onFinishCurrencyForm}
      form={useForm}
      formData={formData.currency}
      currencyData={currencyData}
      onChange={onChangeCurrency}
    />,
    <TermsForm
      onFinish={onFinishTermsForm}
      form={useForm}
      formData={formData.terms}
      interestCompoundingPeriodTypeOptions={interestCompoundingPeriodTypeOptions}
      interestPostingPeriodTypeOptions={interestPostingPeriodTypeOptions}
      interestCalculationTypeOptions={interestCalculationTypeOptions}
      interestCalculationDaysInYearTypeOptions={interestCalculationDaysInYearTypeOptions}
    />,
    <SettingsForm
      onFinish={onFinishSettingsForm}
      form={useForm}
      formData={formData.settings}
      lockinPeriodFrequencyTypeOptions={lockinPeriodFrequencyTypeOptions}
      taxGroupOptions={taxGroupOptions}
      isDormancyTrackingActive={isDormancyTrackingActive}
      setIsDormancyTrackingActive={setIsDormancyTrackingActive}
    />,

    <ChargeForm
      onFinish={onFinishChargeForm}
      form={useForm}
      chargesOptions={chargeBasedOnCurrencyList}
      userData={userData}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      chargeTableSource={chargeTableSource}
      setChargeTableSource={setChargeTableSource}
      initialValues={formData.charges}
      setChargesValue={setChargesValue}
    />,

    <AccountingForm
      onFinish={onFinishAccountForm}
      form={useForm}
      formData={formData.account}
      accountingRuleCheck={accountingRuleCheck}
      setAccountingRuleCheck={setAccountingRuleCheck}
      showAdvancedAccounting={showAdvancedAccounting}
      setShowAdvancedAccounting={setShowAdvancedAccounting}
      handleRadioCheck={handleRadioCheck}
      assetAccountOptions={filteredAssetAccountOptions}
      equityAccountOptions={filteredEquityAccountOptions}
      expenseAccountOptions={filteredExpenseAccountOptions}
      incomeAccountOptions={filteredIncomeAccountOptions}
      liabilityAccountOptions={filteredLiabilityAccountOptions}
      paymentTypeOptions={paymentTypeOptions}
      charges={charges}
      penaltyOptions={penaltyOptions}
      userData={userData}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      configureFundTableSource={configureFundTableSource}
      setConfigureFundTableSource={setConfigureFundTableSource}
      mapFeeTableSource={mapFeeTableSource}
      setMapFeeTableSource={setMapFeeTableSource}
      mapPenaltyTableSource={mapPenaltyTableSource}
      setMapPenaltyTableSource={setMapPenaltyTableSource}
      setChargesValue={setChargesValue}
      fundCount={fundCount}
      setFundCount={setFundCount}
      feeCount={feeCount}
      setFeeCount={setFeeCount}
      penaltyCount={penaltyCount}
      setPenaltyCount={setPenaltyCount}
      isDormancyTrackingActive={isDormancyTrackingActive}
    />,
    <Preview
      formData={formData}
      currencyData={currencyData}
      templateProdDetail={templateProdDetail}
      chargeTableSource={chargeTableSource}
      configureFundTableSource={configureFundTableSource}
      mapFeeTableSource={mapFeeTableSource}
      mapPenaltyTableSource={mapPenaltyTableSource}
      showAdvancedAccounting={showAdvancedAccounting}
    />,
  ];

  const isLastStep = current === forms.length - 1;

  const nextButtonClick = () => {
    useForm.submit();
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };

  const getTemplate = () => {
    setIsLoading(true);

    const url = apiConfig.GetTemplateProductList;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setTemplateProdDetail(res);
        const objList = res;
        let tempFunds = [];
        let tempCurrency = [];
        let tempInterestCompoundingPeriodTypeOptions = [];
        let tempInterestPostingPeriodTypeOptions = [];
        let tempInterestCalculationTypeOptions = [];
        let tempInterestCalculationDaysInYearTypeOptions = [];
        let tempLockinPeriodFrequencyTypeOptions = [];
        let tempTaxGroupOptions = [];
        let tempAssetOptions = [];
        let tempEquityOptions = [];
        let tempExpenseOptions = [];
        let tempIncomeOptions = [];
        let tempLiabilityOptions = [];
        let tempCharges = [];
        let tempChargesOptions = [];
        let tempPenaltyOptions = [];
        let tempPaymentTypeOptions = [];

        // console.log(objList);
        useForm.setFieldsValue({
          digitsAfterDecimal: objList?.currencyOptions[0]?.decimalPlaces,
          currencyCode: objList?.currencyOptions[0]?.code,
          interestCompoundingPeriodType: objList?.interestCompoundingPeriodType?.id,
          interestPostingPeriodType: objList?.interestPostingPeriodType?.id,
          interestCalculationType: objList?.interestCalculationType?.id,
          interestCalculationDaysInYearType: objList?.interestCalculationDaysInYearType?.id,
        });

        objList?.fundOptions?.forEach((element) => {
          tempFunds.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.currencyOptions?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.displayLabel,
            decimalPlaces: element.decimalPlaces,
          });
        });
        objList?.interestCompoundingPeriodTypeOptions?.forEach((element) => {
          tempInterestCompoundingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestPostingPeriodTypeOptions?.forEach((element) => {
          tempInterestPostingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestCalculationTypeOptions?.forEach((element) => {
          tempInterestCalculationTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestCalculationDaysInYearTypeOptions?.forEach((element) => {
          tempInterestCalculationDaysInYearTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.lockinPeriodFrequencyTypeOptions?.forEach((element) => {
          tempLockinPeriodFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.taxGroupOptions?.forEach((element) => {
          tempTaxGroupOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.accountingMappingOptions?.assetAccountOptions?.forEach((element) => {
          tempAssetOptions.push({
            value: element.id,
            label: `${element.glCode} (${element.name})`,
            currencyCode: element?.currencyCode,
          });
        });
        objList?.accountingMappingOptions?.equityAccountOptions?.forEach((element) => {
          tempEquityOptions.push({
            value: element.id,
            label: `${element.glCode} (${element.name})`,
            currencyCode: element?.currencyCode,
          });
        });
        objList?.accountingMappingOptions?.expenseAccountOptions?.forEach((element) => {
          tempExpenseOptions.push({
            value: element.id,
            label: `${element.glCode} (${element.name})`,
            currencyCode: element?.currencyCode,
          });
        });
        objList?.accountingMappingOptions?.incomeAccountOptions?.forEach((element) => {
          tempIncomeOptions.push({
            value: element.id,
            label: `${element.glCode} (${element.name})`,
            currencyCode: element?.currencyCode,
          });
        });
        objList?.accountingMappingOptions?.liabilityAccountOptions?.forEach((element) => {
          tempLiabilityOptions.push({
            value: element.id,
            label: `${element.glCode} (${element.name})`,
            currencyCode: element?.currencyCode,
          });
        });
        objList?.paymentTypeOptions?.forEach((element) => {
          tempPaymentTypeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.chargeOptions?.forEach((element) => {
          tempCharges.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.chargeOptions?.forEach((element) => {
          tempChargesOptions.push({
            value: element.id,
            label: `${element.name}(${element?.currency?.name})`,
            currencyName: element?.currency?.name,
            currencyCode: element?.currency?.code,
          });
        });

        objList?.penaltyOptions?.forEach((element) => {
          tempPenaltyOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        setFundsData(tempFunds);
        setCurrencyData(tempCurrency);
        setInterestCompoundingPeriodTypeOptions(tempInterestCompoundingPeriodTypeOptions);
        setInterestPostingPeriodTypeOptions(tempInterestPostingPeriodTypeOptions);
        setInterestCalculationTypeOptions(tempInterestCalculationTypeOptions);
        setInterestCalculationDaysInYearTypeOptions(tempInterestCalculationDaysInYearTypeOptions);
        setLockinPeriodFrequencyTypeOptions(tempLockinPeriodFrequencyTypeOptions);
        setTaxGroupOptions(tempTaxGroupOptions);
        setAssetAccountOptions(tempAssetOptions);
        setEquityAccountOptions(tempEquityOptions);
        setExpenseAccountOptions(tempExpenseOptions);
        setIncomeAccountOptions(tempIncomeOptions);
        setLiabilityAccountOptions(tempLiabilityOptions);
        setPaymentTypeOptions(tempPaymentTypeOptions);
        setCharges(tempCharges);
        setChargesOptions(tempChargesOptions);
        setPenaltyOptions(tempPenaltyOptions);
        let tempChargeForTableData = tempChargesOptions.filter(
          (item) => item.currencyCode === tempCurrency[0]?.value
        );

        setChargeBasedOnCurrencyList(tempChargeForTableData);
        setIsLoading(false);
      }
    });
  };

  const onSubmit = () => {
    let formValues = {
      ...formData.details,
      ...formData.currency,
      ...formData.terms,
      ...formData.settings,
    };

    formValues.digitsAfterDecimal = +formData?.currency?.digitsAfterDecimal;
    formValues.nominalAnnualInterestRate = +formData?.terms?.nominalAnnualInterestRate;

    formValues.accountingRule = "2";
    formValues.incomeFromFeeAccountId = formData?.account?.incomeFromFeeAccountId;
    formValues.incomeFromInterestId = formData?.account?.incomeFromInterestId;
    formValues.incomeFromPenaltyAccountId = formData?.account?.incomeFromPenaltyAccountId;
    formValues.interestOnSavingsAccountId = formData?.account?.interestOnSavingsAccountId;
    formValues.overdraftPortfolioControlId = formData?.account?.overdraftPortfolioControlId;
    formValues.savingsControlAccountId = formData?.account?.savingsControlAccountId;
    formValues.savingsReferenceAccountId = formData?.account?.savingsReferenceAccountId;
    formValues.transfersInSuspenseAccountId = formData?.account?.transfersInSuspenseAccountId;
    formValues.escheatLiabilityId = formData?.account?.escheatLiabilityId;
    formValues.writeOffAccountId = formData?.account?.writeOffAccountId;
    formValues.paymentChannelToFundSourceMappings = formData?.paymentChannelToFundSourceMappings;
    formValues.feeToIncomeAccountMappings = formData?.feeToIncomeAccountMappings;
    formValues.penaltyToIncomeAccountMappings = formData?.penaltyToIncomeAccountMappings;
    formValues.charges = formData.charges;

    // TODO
    // delete formValues.forfeitInterest;

    // console.log(formValues);
    // return;

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      apiConfig.NewCasaProductList,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.newCasaCreatedMsg);
          navigate("/prd0100");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/prd0100");
          setIsLoading(false);
        },
      }
    );
  };

  function onCancel() {
    navigate("/prd0100", { replace: false });
  }
  const steps = ["details", "currency", "terms", "settings", "charges", "accounting", "preview"];

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit} currentStep={steps[current]}>
      <TopContent
        pageTitle={labelConfig.AddCASAProducts}
        pageItems={staticConfig.newCasaProductItems}
      />
      <Spin spinning={isLoading} tip="Loading..." size="large">
        <Card title={"Product Setup"} style={styles.cardWrapper}>
          <div>
            <Row
              gutter={{
                xs: 8,
                sm: 16,
                md: 24,
                lg: 32,
              }}
              style={{ marginBottom: 25 }}
            >
              <Col span={24}>
                <Row style={{ justifyContent: "space-between" }}>
                  <Card style={styles.cardSteps}>
                    <Steps
                      current={current}
                      onChange={setCurrent}
                      direction="vertical"
                      style={{ height: "600px" }}
                      items={[
                        {
                          title: <Text strong>Details</Text>,
                        },
                        {
                          title: <Text strong>Currency</Text>,
                        },
                        {
                          title: <Text strong>Terms</Text>,
                        },
                        {
                          title: <Text strong>Settings</Text>,
                        },
                        {
                          title: <Text strong>Charges</Text>,
                        },
                        {
                          title: <Text strong>Accounting</Text>,
                        },
                        {
                          title: <Text strong>Preview</Text>,
                        },
                      ]}
                    />
                  </Card>
                  {/* Form Section */}
                  <Card style={styles.cardStepDisplay}>
                    <div>{forms[current]}</div>
                    {/* </Form> */}
                  </Card>
                </Row>
              </Col>
            </Row>

            {/* Submitt section */}
            <Card
              style={{
                marginBottom: 25,
                boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                borderRadius: 20,
                padding: 5,
              }}
            >
              <Flex justify="space-between" style={{ paddingLeft: "20px", paddingRight: "40px" }}>
                {current === 0 && (
                  <Button
                    style={{
                      width: "12%",
                      height: "15%",
                      backgroundColor: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                      color: "black",
                    }}
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                )}
                {current > 0 && (
                  <Button
                    style={{
                      width: "10%",
                      height: "15%",
                      backgroundColor: "#15CCAE",
                      color: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                    }}
                    onClick={prevButtonClick}
                  >
                    {labelConfig.previous}
                  </Button>
                )}
                {!isLastStep && (
                  <Button
                    style={{
                      width: "10%",
                      height: "15%",
                      backgroundColor: "#15CCAE",
                      color: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                    }}
                    onClick={nextButtonClick}
                  >
                    {labelConfig.next}
                  </Button>
                )}
                {BOM.HasPermission("CREATE_SAVINGSPRODUCT") && isLastStep && (
                  <CustomButton
                    content="Submit"
                    style={{
                      width: "10%",
                      marginLeft: "auto",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    onClick={onSubmit}
                    backgroundColor="#fff"
                    colorText="black"
                    hoverBackground="#F5F5F5"
                  />
                )}
              </Flex>
            </Card>
          </div>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AddPRD0100);
